import { useEffect } from "react";
import { useAuth } from "../../Common/Hooks/useAuth";
import { identifyMixpanelUser, resetMixpanelUser } from "../../Common/Services/Mixpanel";

/** Keeps browser replays associated with the authenticated product user. */
export const MixpanelIdentity = () => {
  const { clientUser } = useAuth();

  useEffect(() => {
    if (clientUser) {
      identifyMixpanelUser(clientUser.id);
      return;
    }

    resetMixpanelUser();
  }, [clientUser]);

  return null;
};
